import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import React, { ReactNode, useState } from "react";
import { Divider } from "@mui/material";

export interface WrappedMenuProps {
  shownElement: (open: boolean, onClick: (event: any) => void) => JSX.Element;
  onClick?: (event: any, handleClose: () => void) => void;
  onClose?: (closer: () => void) => void;
  children: string | JSX.Element | JSX.Element[] | ReactNode;
}

export function WrappedMenu(props: WrappedMenuProps) {
  const [searchParams] = useSearchParams();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function logoutHandler() {
    window.location.href = "/auth/logout";
  }
  return (
    <>
      {props.shownElement(open, handleClick)}
      <Menu
        MenuListProps={{ "aria-labelledby": "long-button" }}
        anchorEl={anchorEl}
        open={open}
        onClose={() => {
          if (props.onClose) {
            props.onClose(handleClose);
          } else {
            handleClose();
          }
        }}
        id="account-menu"
        onClick={(event: any) => {
          if (props.onClick) {
            props.onClick(event, handleClose);
          } else {
            handleClose();
          }
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiButtonBase-root": {
              fontFamily: "Saira",
            },
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {props.children}
      </Menu>
    </>
  );
}

export default function HamburgerMenu({ onPageChange }: any) {
  const navigate = useNavigate();
  const [closer, setCloser] = useState<(() => void) | undefined>(undefined);
  const [accountSubmenuShown, setAccountSubmenuShown] = useState(false);

  return (
    <WrappedMenu
      shownElement={(open: boolean, onClick: (event: any) => void) => (
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={open ? "long-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={onClick}
        >
          <MenuRoundedIcon fontSize="large" sx={{ color: "#0c0c0c" }} />
        </IconButton>
      )}
      onClick={(event: any, handleClose: () => void) => {
        setCloser((o) => {
          if (!o) {
            return handleClose;
          }
          return o;
        });
      }}
      onClose={(closer: () => void) => {
        setAccountSubmenuShown(false);
        closer();
      }}
    >
      <MenuItem onClick={() => {
          if (closer) {
            closer();
          }
          navigate("/dashboard");
        }}>
        Issued credentials
      </MenuItem>
      <MenuItem onClick={() => {
          if (closer) {
            closer();
          }
          navigate("/create_credential");
        }}>
        Issue credential
      </MenuItem>
      <MenuItem onClick={() => {
          if (closer) {
            closer();
          }
          navigate("/add_issuance");
        }}>
        Add credential template
      </MenuItem>
      <MenuItem
        onClick={() => {
          if (closer) {
            closer();
          }
          navigate("/settings");
        }}
      >
        Account settings
      </MenuItem>
      <Divider />
      <MenuItem
        onClick={() => {
          window.location.href = "/auth/logout";
        }}
      >
        Logout
      </MenuItem>

      {/* {accountSubmenuShown && (
        <div key={"submenu"}>
          <Divider />
          <MenuItem
            onClick={() => {
              onPageChange("/api_key");
              navigate("/api_key");
              if (closer) {
                setAccountSubmenuShown(false);
                closer();
              }
            }}
          >
            API Keys
          </MenuItem>
          <MenuItem
            onClick={() => {
              onPageChange("/key_management");
              navigate("/key_management");
              if (closer) {
                setAccountSubmenuShown(false);
                closer();
              }
            }}
          >
            Key management
          </MenuItem>
          <Divider />
        </div>
      )} */}
    </WrappedMenu>
  );
}
